import CallApi from '../hooks/callApi';

export async function fetchChatHistory(sessionId) {
  return CallApi({
    method: 'GET',
    url: `/history/${encodeURIComponent(sessionId)}`,
  });
}

